<template>
  <div id="contenedor-main-oficio-autorizacion" class="bkground">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar
            :oficio="getOficio"
            :cargando="$apollo.queries.oficioAutorizacion.loading">
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card color="transparent" flat>
        <v-card-text class="pa-0">
          <router-view
            :oficio="getOficio"
            :cargando="$apollo.queries.oficioAutorizacion.loading">
          </router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import OFICIO_AUTORIZACION from '@/graphql/querys/administracion/programacion/oficiosautorizacion/oficioAutorizacion.gql';
import TituloToolBar from './TituloToolBar.vue';

export default {
  name: 'MainOficioAutorizacion',
  components: {
    TituloToolBar,
  },
  data() {
    return {};
  },
  apollo: {
    oficioAutorizacion: {
      query: OFICIO_AUTORIZACION,
      variables() {
        return {
          id: this.$route.params.idOficio,
        };
      },
      skip() {
        return !this.$route.params.idOficio;
      },
    },
  },
  computed: {
    getOficio() {
      if (!this.oficioAutorizacion) return {};
      return this.oficioAutorizacion;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
